import { useNavigate } from 'react-router-dom';
import { CacheAreaKey } from 'core/config/cache-config';
import { ActionOverlays } from 'core/enums/overlay/action-overlays';
import { PaymentAttribution, PaymentType } from 'core/enums/payment-type';
import { Account, Quote } from 'core/models/account/amount-to-pay.dto';
import { Product } from 'core/models/product/product';
import { StorageHelper } from 'core/services/storage';
import { PaymentMetaData } from 'payment/payment.context';

export const useMakePayment = () => {
  const navigate = useNavigate();
  const makePaymentPath = `/action?action=${ActionOverlays.MakePayment}`

  const payQuote = (payQuoteReq: {
    returnLocation: string,
    quote: Quote,
    journeyName?: string,
    amountToPayOverride?: string,
    paymentMetaData: PaymentMetaData
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payQuoteReq, paymentType: PaymentType.Quotation } })
  }

  const payAmount = (payAmountReq: {
    returnLocation: string,
    amountToPay: string,
    account: Account,
    paymentMetaData: PaymentMetaData
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payAmountReq, paymentType: PaymentType.Amount } })
  }

  const payChangePackage = (payChangePackageReq: {
    returnLocation: string,
    quote: Quote,
    fromPackage: Partial<Product>,
    toPackage: Partial<Product>,
    paymentMetaData: PaymentMetaData
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payChangePackageReq, paymentType: PaymentType.ChangePackage } })
  }

  const payBill = (payBillReq: {
    returnLocation: string,
    product: Partial<Product>,
    paymentAttribution?: PaymentAttribution
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payBillReq, paymentType: PaymentType.Bill } })
  }

  const payBoxoffice = (payBoxofficeReq: {
    returnLocation: string,
    account: Account,
    amount: string,
    balance: string,
    paymentMetaData: PaymentMetaData
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payBoxofficeReq, paymentType: PaymentType.BoxOffice } })
  }

  const tokenPayment = (payAmountReq: {
    returnLocation: string,
    amountToPay: string,
    showNotice?: boolean,
    account: Account,
    paymentMetaData: PaymentMetaData
  }) => {
    StorageHelper.GetInstance.removeFromStorage('sessions', CacheAreaKey.Payments)
    navigate(makePaymentPath, { state: { ...payAmountReq, paymentType: PaymentType.Tokenize } })
  }

  return {
    payQuote,
    payAmount,
    payChangePackage,
    payBill,
    payBoxoffice,
    tokenPayment,
  }
}